import { Fragment } from 'react';

function SidebarLogo({ image, collapsedImage, imageAlt, collapsedImageAlt }) {
  return (
    <Fragment>
      <img
        className="hidden h-8 w-full object-contain object-center xl:block"
        src={image}
        alt={imageAlt}
      />
      <img
        className="h-8 w-8 object-contain object-center xl:hidden"
        src={collapsedImage}
        alt={collapsedImageAlt}
      />
    </Fragment>
  );
}

export default SidebarLogo;
